// Third Party Plugin// Third Party Plugins
import React from 'react';

// Types
import { BaseButtonProps } from './types';

// Custom Components
import SolidButton from '../SolidButton';
import OutlineButton from '../Outline';
import MinorButton from '../MinorButton';

function BaseButton({
  link,
  action,
  theme,
  disabled,
  actionType, // ✅ default to button (SAFE)
  children,
  ...props
}: BaseButtonProps) {
  // ✅ Only include action if it actually exists
  const actionProps = action ? { action } : {};

  // ✅ Only include link when not a button
  const linkProps = actionType !== 'button' && link ? { link } : {};

  switch (theme) {
    case 'outline':
      return (
        <OutlineButton
          {...linkProps}
          {...actionProps}
          actionType={actionType}
          disabled={disabled}
          {...props}
        >
          {children}
        </OutlineButton>
      );

    case 'minor':
      return (
        <MinorButton
          {...linkProps}
          {...actionProps}
          actionType={actionType}
          disabled={disabled}
          {...props}
        >
          {children}
        </MinorButton>
      );

    case 'solid':
    default:
      return (
        <SolidButton
          {...linkProps}
          {...actionProps}
          actionType={actionType}
          disabled={disabled}
          {...props}
        >
          {children}
        </SolidButton>
      );
  }
}

export default BaseButton;
